export default __webpack_public_path__ + "static/media/ISWEC-3.30419157.pdf";